var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filters-container", attrs: { id: "filters" } },
    _vm._l(_vm.mappedFilters, function(filters) {
      return _c("GenericFilter", {
        key: filters.category,
        attrs: { filters: filters }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }